/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IDobbiesNavigationMenu containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum navigationMenuSource {
    all = 'all',
    retailServerOnly = 'retailServerOnly',
    cmsOnly = 'cmsOnly'
}

export interface IDobbiesNavigationMenuConfig extends Msdyn365.IModuleConfig {
    navigationMenuSource?: navigationMenuSource;
    cmsNavItems?: ICmsNavItemsData[];
    enableMultilevelMenu?: boolean;
    enabletopMenu?: boolean;
    menuLevelSupport?: number;
    rootMenuNavigation?: string;
    displayCategoryImage?: boolean;
    displayPromotionalImage?: boolean;
    categoryPromotionalContent?: ICategoryPromotionalContentData[];
    categoryImageSettings?: Msdyn365.IImageSettings;
    className?: string;
    clientRender?: boolean;
    cmsNavItemsNew?: ICmsNavItemsNewData[];
    hideMenuItemPrefix?: string;
    menuImagesSchedule?: IMenuImagesScheduleData[];
    removeExtraSubMenusOnMobile?: string[];
    removeStaticMenuOnDesktop?: string[];
    subMenuStaticMenus?: ISubMenuStaticMenusData[];
    menuHeading?: string;
    dobbiesClubNavItemText?: string;
    clubFreeTierText?: string;
    clubPlusTierText?: string;
    showOptionAll?: boolean;
    imageSettings?: IImageSettingsData[];
    categoryImageLinks?: ICategoryImageLinksData[];
    removeDomainFromCategoryURLs?: boolean;
}

export interface IDobbiesNavigationMenuResources {
    menuAriaLabel: string;
    backButtonAriaLabel: string;
    allCategoryMenuText: string;
}

export interface ICmsNavItemsData {
    linkText?: string;
    linkUrl?: Msdyn365.ILinkData;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
    custom_classname?: string;
    custom_background?: string;
    custom_color?: string;
    subMenus?: ISubMenusData[];
}

export interface ICategoryPromotionalContentData {
    categoryName?: string;
    image: Msdyn365.IImageData;
    text?: string;
    linkUrl: Msdyn365.ILinkData;
}

export interface ICmsNavItemsNewData {
    linkText?: string;
    linkUrl?: Msdyn365.ILinkData;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
    custom_classname?: string;
    custom_background?: string;
    custom_color?: string;
    subMenus?: ISubMenusData[];
}

export interface IMenuImagesScheduleData {
    menuName: string;
    menuImageName: string;
    imageShowStartDate: string;
    imageShowEndDate: string;
    imageUrl?: string;
    isForMobile?: boolean;
}

export interface ISubMenuStaticMenusData {
    linkText?: string;
    linkUrl?: Msdyn365.ILinkData;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
    custom_classname?: string;
    custom_background?: string;
    custom_color?: string;
    subMenus?: ISubMenusData[];
}

export interface IImageSettingsData {
    width?: number;
    height?: number;
}

export interface ICategoryImageLinksData {
    categoryName?: string;
    categoryImageLink?: Msdyn365.ILinkData;
}

export interface ISubMenusData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    custom_classname?: string;
    custom_background?: string;
    custom_color?: string;
    subMenus?: ISubMenusData[];
}

export interface ISubMenusData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    custom_classname?: string;
    custom_background?: string;
    custom_color?: string;
    subMenus?: ISubMenusData[];
}

export interface ISubMenusData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    custom_classname?: string;
    custom_background?: string;
    custom_color?: string;
    subMenus?: ISubMenusData[];
}

export interface ISubMenusData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    custom_classname?: string;
    custom_background?: string;
    custom_color?: string;
}

export interface ISubMenusData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    custom_classname?: string;
    custom_background?: string;
    custom_color?: string;
}

export interface ISubMenusData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    custom_classname?: string;
    custom_background?: string;
    custom_color?: string;
}

export interface IDobbiesNavigationMenuProps<T> extends Msdyn365.IModule<T> {
    resources: IDobbiesNavigationMenuResources;
    config: IDobbiesNavigationMenuConfig;
    slots: {
        search: React.ReactNode[];
    };
}
